const c = {
  name: "WorldLatinAmerica",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C9.3,6.7,8.8,7.3,8.8,8C8.8,8.7,9.3,9.2,10,9.2z"/>
		<path class="st0" d="M9.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2S7.3,9.7,8,9.7C8.7,9.7,9.3,10.3,9.3,11z"/>
		<path class="st0" d="M13.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C12.7,9.7,13.3,10.3,13.3,11z"/>
		<path class="st0" d="M16,12.2c0.7,0,1.2-0.6,1.2-1.2S16.7,9.7,16,9.7c-0.7,0-1.2,0.6-1.2,1.2S15.3,12.2,16,12.2z"/>
		<path class="st0" d="M15.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C14.7,12.7,15.3,13.3,15.3,14z"/>
		<path class="st0" d="M18,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S17.3,15.2,18,15.2z"/>
		<path class="st0" d="M35.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C34.7,12.7,35.3,13.3,35.3,14z"/>
		<path class="st0" d="M15.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,6.7,15.3,7.3,15.3,8z"/>
		<path class="st0" d="M12,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,17.7,11.3,18.2,12,18.2z"
			/>
		<path class="st0" d="M17.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,15.7,17.3,16.3,17.3,17z"
			/>
		<path class="st0" d="M20,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,17.7,19.3,18.2,20,18.2z"
			/>
		<path class="st0" d="M25.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,15.7,25.3,16.3,25.3,17z"
			/>
		<path class="st0" d="M14,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,20.7,13.3,21.2,14,21.2z"
			/>
		<path class="st0" d="M19.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,18.7,19.3,19.3,19.3,20z"
			/>
		<path class="st0" d="M22,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,20.7,21.3,21.2,22,21.2z"
			/>
		<path class="st0" d="M27.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,18.7,27.3,19.3,27.3,20z"
			/>
		<path class="st0" d="M16,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,23.7,15.3,24.2,16,24.2z"
			/>
		<path class="st0" d="M21.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,21.7,21.3,22.3,21.3,23z"
			/>
		<path class="st0" d="M24,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,23.7,23.3,24.2,24,24.2z"
			/>
		<path class="st0" d="M19.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,24.7,19.3,25.3,19.3,26z"
			/>
		<path class="st0" d="M22,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,26.7,21.3,27.2,22,27.2z"
			/>
		<path class="st0" d="M17.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,27.7,17.3,28.3,17.3,29z"
			/>
		<path class="st0" d="M20,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,29.7,19.3,30.2,20,30.2z"
			/>
		<path class="st0" d="M15.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C14.7,30.7,15.3,31.3,15.3,32z"
			/>
		<path class="st0" d="M16,36.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S15.3,36.2,16,36.2z"/>
		<path class="st0" d="M36.8,9.2c0.4,0.7,0.8,1.3,1.1,2h0c1.4,2.7,2,5.7,2,8.8c0,11-9,20-20,20S0,31,0,20c0-3,0.7-6,2-8.7l0-0.1
			c0.3-0.7,0.7-1.3,1.1-2c0.3-0.5,0.6-0.9,0.9-1.3c0.5-0.6,1-1.2,1.6-1.8c0.3-0.3,0.6-0.6,0.9-0.9c0.7-0.6,1.3-1.1,2-1.6
			C11.9,1.2,15.9,0,20,0c5.5,0,10.6,2.2,14.4,6.1c0.6,0.6,1.1,1.2,1.6,1.8C36.2,8.3,36.5,8.7,36.8,9.2z M2,20c0,9.9,8.1,18,18,18v0
			c9.9,0,18-8.1,18-18c0-2.7-0.6-5.4-1.8-7.8c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8
			c-0.2-0.3-0.4-0.7-0.7-1c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5C29.5,3.9,24.9,2,20,2
			c-2.7,0-5.4,0.6-7.8,1.8c0.6,0.1,1.1,0.6,1.1,1.2c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0-0.3,0.1-0.5
			C10.5,4.7,10.1,5,9.7,5.3C9.4,5.4,9.2,5.6,8.9,5.8C8.9,5.9,8.8,6,8.7,6.1C8.4,6.2,8.2,6.5,7.9,6.7C7.6,6.9,7.4,7.2,7.1,7.5
			C7.2,7.6,7.3,7.8,7.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1c0.2,0.2,0.3,0.5,0.3,0.8
			c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0C2.6,14.6,2,17.3,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldLatinAmerica
};
